// extracted by mini-css-extract-plugin
module.exports = {"content5":"styles_content5__1EJ0M","section":"styles_section__NiLlL","box":"styles_box__1bO1x","article":"styles_article__2zr5a"};